import React, { Component } from 'react';
import { Button, Card, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
import { Fetcher } from '../../../Helpers/fetcher';
import { Notify } from '../../../Helpers/notification';
class ListPilotApiCli extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cliList: [],
            sizePerPage: 10,
            pilotNumber: '',
            loading: false,
        }
    }

    getCli = () => {
        const apiPath = this.props.app.apiPath;
        const { pilotNumber } = this.state;

        if (!pilotNumber) {
            return;
        }
        this.setState({ loading: true });
        Fetcher.get(`${apiPath}/api/obd/cli/pilot/${pilotNumber}`)
            .then(res => {
                if (res.error) return
                this.setState({ cliList: res || [] });
            })
            .catch(err => {
                console.log('Error in fetching CLI List', err);
                Notify.notify("Error while fetching.")
                this.setState({ cliList: [] });
            }).finally(() => this.setState({ loading: false }));
    };

    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('pilotcliListsizePerPage', newSizePerPage);
    }

    render() {
        const cliList = this.state.cliList;
        let columns = [
            {
                dataField: 'cliId',
                text: 'CLI Id',
                sort: true,
                hidden: false
            },
            {
                dataField: 'cli',
                text: 'CLI',
                sort: true,
                searchable: true
            },
            {
                dataField: 'cliStatus',
                text: 'Status',
                sort: true,
                searchable: true
            },
            {
                dataField: 'pilotNumber',
                text: 'Pilot Number',
                sort: true,
                searchable: true
            }];
        const clis = Array.isArray(cliList) ? cliList.map((cli, index) => {
            let status = '';
            switch (cli.cliStatus) {
                case 1:
                    status = 'Unarchived';
                    break;
                case 2:
                    status = 'Archived';
                    break;
                default:
                    status = '';
                    break;
            }
            return {
                cliId: cli.cliId,
                cli: cli.cli,
                cliStatus: status,
                pilotNumber: cli.pilotNumber,
                allocationDate: cli.allocationDate ?? '',
            };

        }) : []
        const { SearchBar, ClearSearchButton } = Search;
        const { ExportCSVButton } = CSVExport;

        const defaultSorted = [{
            dataField: 'allocationDate',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: clis.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };
        return (
            <Card>
                <Card.Header>
                    Pilot Api CLI List
                </Card.Header>
                <Card.Body>
                    <div className="d-flex mb-3">
                        <input
                            type="text"
                            className="form-control mr-2"
                            style={{ maxWidth: '250px' }}
                            placeholder="Enter Pilot Number"
                            name="pilotNumber"
                            value={this.state.pilotNumber}
                            onChange={this.setvalue}
                        />
                        <Button variant="primary" onClick={this.getCli} disabled={this.state.loading}>
                            {this.state.loading ? 'Searching...' : 'Search'}
                        </Button>
                    </div>

                    <div className="widget-list-table-cont">
                        {this.state.loading ? (
                            <div className="text-center my-4">
                                <Spinner animation="border" variant="primary" />
                                <div className="mt-2">Loading...</div>
                            </div>
                        ) : (<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (
                                    <ToolkitProvider
                                        keyField="cliId"
                                        data={clis}
                                        columns={columns}
                                        search
                                        bootstrap4
                                        exportCSV={{
                                            fileName: 'pilotcli.csv'
                                        }}

                                    >
                                        {
                                            props => (
                                                <div className="">
                                                    Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                    <span className="search-cont"><SearchBar  {...props.searchProps} /></span>
                                                    <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                                    <ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton>

                                                    <BootstrapTable defaultSorted={defaultSorted} bordered={true} hover condensed wrapperClasses="table-responsive" classes="mt-3  widgetlist-table"  {...props.baseProps}  {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
                                                    <PaginationListStandalone {...paginationProps} />
                                                    <ReactTooltip />
                                                </div>
                                            )
                                        }
                                    </ToolkitProvider>
                                )
                            }
                        </PaginationProvider>)}
                    </div>
                </Card.Body>
            </Card>

        );
    }
}

export default ListPilotApiCli;